var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,23.38A16.61,16.61,0,0,1,22,26.28a14.43,14.43,0,0,1-2,2.51A3.79,3.79,0,0,1,17.46,30a6.2,6.2,0,0,1-2.35-.59,6.29,6.29,0,0,0-2.52-.59,6.52,6.52,0,0,0-2.59.59A6.82,6.82,0,0,1,7.76,30a3.56,3.56,0,0,1-2.6-1.21,15.19,15.19,0,0,1-2.06-2.6A18.19,18.19,0,0,1,.92,21.63,17.59,17.59,0,0,1,0,16.19,10.29,10.29,0,0,1,1.24,11,7.51,7.51,0,0,1,3.83,8.22a6.78,6.78,0,0,1,3.51-1,8,8,0,0,1,2.72.67,8.2,8.2,0,0,0,2.15.66,12.7,12.7,0,0,0,2.39-.78,7.4,7.4,0,0,1,3.24-.61,6.79,6.79,0,0,1,5.39,3,6.4,6.4,0,0,0-3.18,5.74A6.72,6.72,0,0,0,24,22c-.16.48-.33.94-.5,1.39ZM18,.6a6.6,6.6,0,0,1-1.56,4.2A5.22,5.22,0,0,1,12,7.09a5.17,5.17,0,0,1,0-.57,6.74,6.74,0,0,1,1.65-4.24,6.32,6.32,0,0,1,2-1.59A5.73,5.73,0,0,1,18,0q0,.3,0,.6Z",
    fill: "#b3b3b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.99a9a9b6cd9cbc4dfa8386622716dc78.svg";
export { ForwardRef as ReactComponent };